import React from 'react';

export const EventContext = React.createContext({
    attendees: [],
    setAttendees: (attendees) => [],
    percentages: {},
    setPercentages: (e) => {},
    pairingEvents: [],
    setPairingEvents: (e) => {},
    pairingEvent: {},
    setPairingEvent: (pairingEvent) => {},
    roundInfo: {paused:false, round:1,roundStart:null},
    displayData: {},
    setDisplayData: (displayData) => {},
    setRoundInfo: (roundInfo) => {},
    pairingData: null,
    setPairingData: (pairingData) => {},
    missingRounds: [],
    setMissingRounds: (missingRounds) => {},
    backToBackBreaks: [],
    setBackToBackBreaks: (e) => {},
    userData: null, 
    setUserData: (userData) => {},
    socket: null
});